<template>
  <div class="animated fadeIn">
    <b-card-group class="mb-12">
      <!-- GRAFIK TOTAL NON GT -->
      <b-card class="col-sm-3 col-md-3 col-lg-3">
        <div class="h4 text-muted text-right">
          <i class="icon-people"></i>&nbsp;Total Request Freezer
        </div>
        <div class="small text-muted text-right mb-4">
          Total Request Penempatan / Penarikan Freezer
        </div>

        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            :key="uniqueId('asset-owner')"
            :doughnut-label="total_freezer_status.label"
            :doughnut-data="total_freezer_status.data"
            :doughnut-color="total_freezer_status.color"
            chartId="asset-owner-01"
          ></doughnut-example>
          <br />
          <table-total
            :clickAble="true"
            :tableData="total_freezer_status"
            :title="'total_freezer_status'"
          ></table-total>
        </div>
        <loading v-else></loading>
      </b-card>

      <b-card class="col-sm-3 col-md-3 col-lg-3">
        <div class="h4 text-muted text-right">
          <i class="icon-people"></i>&nbsp;Status Freezer
        </div>
        <div class="small text-muted text-right mb-4">
          Total Status Kondisi Freezer
        </div>

        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            :key="uniqueId('asset-owner')"
            :doughnut-label="asset_freezer.label"
            :doughnut-data="asset_freezer.data"
            :doughnut-color="asset_freezer.color"
            chartId="asset-owner-01"
          ></doughnut-example>
          <br />
          <table-total
            :clickAble="true"
            :tableData="asset_freezer"
            :title="'asset_freezer'"
          ></table-total>
        </div>
        <loading v-else></loading>
      </b-card>

      <!-- TABEL TOTAL NON GT -->
    </b-card-group>

    <br/>

    <b-card-group class="mb-4">
      <b-card class="col-sm-12 col-md-9 col-lg-9">
        <div class="h4 text-muted text-right">
          <i class="icon-home"></i>&nbsp;Tabel asset
        </div>
        <div class="small text-muted text-right mb-4">
          List asset <b></b> yang <b>belum digunakan</b>
        </div>

        <div class="chart-wrapper">
          <b-button
            v-if="!loading_asset_no_used"
            class="btn btn-link"
            variant="excel icon"
            size="sm"
            @click="download"
            ><i class="fa fa-file-excel-o"></i> Export to excel</b-button
          >
          <global-table
            :table-data="asset_no_used"
            :loading="loading_asset_no_used"
            :per-page="7"
            :bordered="true"
            :table-detail="tableDetail"
            :hover="true"
            :striped="false"
            :fields="fields_asset_no_used"
            :redirect-detail="false"
            :show-add-button="false"
            :edit-button="false"
          ></global-table>
        </div>
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import VueNotifications from "vue-notifications";
import loading from "@/templates/Loading.vue";
import LineExample from "@/views/charts/LineExample.vue";
import DoughnutExample from "@/views/charts/DoughnutExample.vue";
import BarExample from "@/views/charts/BarExample.vue";
import * as moment from "moment";
import { ModelSelect } from "vue-search-select";
import tableTotal from "@/templates/TableTotal.vue";

import _ from "lodash";

export default {
  name: "dashboard-customer",
  components: {
    globalTable,
    Callout,
    loading,
    ModelSelect,
    LineExample,
    DoughnutExample,
    BarExample,
    tableTotal,
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      loading: false,
      total_freezer_status: [],
      asset_owner: [],
      asset_freezer: [],
      asset_no_used: [],

      loading_asset_no_used: true,
      asset_no_used: [],
      fields_asset_no_used: [
        { key: "asset_name", label: "Nama Freezer", sortable: true },
        // { key: "serial_number", label: "Nomor Seri", sortable: true },
        { key: "total", label: "Total" },
      ],
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    //gimana caranya biar dapet nama dari tabel total yang udah di klik
    showNameNonGT() {
      let flag = "";
      for (let i in this.asset_owner.label) {
        if (i == this.currState) {
          flag = this.asset_owner.label[i];
        }
      }
      return flag;
    },
  },
  methods: {
    uniqueId: function (param = "") {
      return _.uniqueId(param);
    },
    init: function () {
      this.loading = true;
      this.loading_asset_no_used = true;
      this.axios
        .get("web/dashboard/all-dashboard-for-asset/")
        .then((response) => {
          this.asset_owner = response.data.asset_owner;
          this.total_freezer_status = response.data.total_freezer_status;
          this.asset_freezer = response.data.asset_freezer;
        })
        .catch((error) => {
          this.expired(error);
        })
        .finally(() => {
          this.loading = false;
          this.loading_asset_no_used = false;
        });
    },
    expired: function (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: "Dashboard Konsumen",
          message: error.response.data.message,
        });
      }
    },
    showDetail: function () {
      this.loading_asset_no_used = true;
      this.axios
        .get("web/dashboard/asset-no-used/")
        .then((response) => {
          this.asset_no_used = response.data.asset_no_used;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading_asset_no_used = false;
        });
      this.init();
    },
    download: function () {
      this.loading_asset_no_used = true;
      this.axios({
        url: "web/export/asset/asset-no-used/",
        method: "GET",
        responseType: "arraybuffer", //before "blob"
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "asset_no_used.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.expired(error, "");
          }
        })
        .finally(() => {
          this.loading_asset_no_used = false;
        });
    },
  },
  mounted() {
    //this.dropdown();

    this.showDetail(0);
    this.init();
  },
};
</script>
